import type { Area } from '@placer-ui/types';

export const AREA_TYPE_NATIONWIDE = 'nationwide';

export const NATIONWIDE: Area = {
    name: 'nationwide',
    type: AREA_TYPE_NATIONWIDE,
    code: 'Nationwide',
};
